import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ReactJson from 'react-json-view';
import Clipboard from 'react-clipboard.js';
import Select from 'react-select';

export default function JsonPreview(props) {
  const [host, setHost] = useState('');
  const [code, setCode] = useState(props.code);
  const hostOptions = props.hosts.map((h) => ({ label: h, value: h }));

  const fetchCode = (hostname) => {
    const url = hostname ? `${props.link}?hostname=${hostname}` : props.link;

    fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then((result) => result.json())
      .then((result) => {
        setHost(hostname);
        setCode(result.code);
      })
      .catch(() =>
        setCode({
          error: `There was an error retrieving the rendered ${props.renderedEntity}.`,
        }),
      );
  };

  const hostChanged = (option) => {
    if (!option || option.value === host) {
      return;
    }
    fetchCode(option.value);
  };

  useEffect(() => {
    if (props.open && props.link) {
      fetchCode(props.hosts[0] || '');
    }
  }, [props.open]);

  return (
    <Modal
      shouldCloseOnEsc
      ariaHideApp={false}
      isOpen={props.open}
      onRequestClose={props.onClose}
    >
      <header>
        <Clipboard
          component='span'
          data-clipboard-text={JSON.stringify(code)}
        >
          <button className='ui labeled icon button'>
            <i className='copy icon'></i>
            Copy to Clipboard
          </button>
        </Clipboard>
        <a
          className='closeModal'
          onClick={props.onClose}
        >
          <i className='icon close'></i>
        </a>

        {props.hosts.length === 0 ? (
          <h2>{props.title}</h2>
        ) : (
          <div className='SelectHostField'>
            <label>Render {props.renderedEntity} for host:</label>
            <Select
              searchable
              clearable={false}
              options={hostOptions}
              value={host}
              onChange={hostChanged}
            />
          </div>
        )}
      </header>

      <ReactJson
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={false}
        name={props.name}
        src={code}
      />
    </Modal>
  );
}

JsonPreview.defaultProps = {
  hosts: [],
};
